import PropTypes from 'prop-types';
import accessIcon from 'assets/icons/access.svg';
import Box from 'components/UI/Box/Box';
import Translate from 'components/Translate';
import CmsLink from 'components/UI/CmsLink';

const ALIGNMENTS = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
};

const SimpleCard = (props) => {
  const {
    title = '',
    subtitle = '',
    description = '',
    link = '',
    image = '',
    imageClassName = '',
    align = 'center',
    isExternalLink = null,
  } = props;

  const renderContent = () => {
    return (
      <div className={`flex justify-between ${ALIGNMENTS[align] || ALIGNMENTS.center} gap-1`}>
        {image && (
          <div className='w-[70px] shrink-0 flex justify-center items-center'>
            <img
              src={image}
              alt='card-icon'
              className={`${imageClassName} max-h-[70px] max-w-[70px] -ml-4 -my-4`}
            />
          </div>
        )}
        <div className='flex justify-between items-center gap-2 flex-1 min-w-0'>
          <div className='min-w-0'>
            {title && (
              <Translate className='text-sm font-bold mb-1 text-neutral-800' literal={title} />
            )}
            {subtitle && (
              <Translate className='text-xs mb-1 truncate max-w-[200px] md:max-w-none' literal={subtitle} />
            )}
            {description && (
              <Translate className='text-2xs leading-3 mb-0 text-neutral-500' literal={description} />
            )}
          </div>
          {link && (
            <img src={accessIcon} alt='access' className='shrink-0' />
          )}
        </div>
      </div>
    );
  };

  return (
    <Box className='mb-2' padding='sm'>
      {link ? (
        <CmsLink to={link} external={isExternalLink} className='no-underline block w-full'>
          {renderContent()}
        </CmsLink>
      ) : (
        renderContent()
      )}
    </Box>
  );
};

SimpleCard.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  imageClassName: PropTypes.string,
  isExternalLink: PropTypes.bool,
  align: PropTypes.string,
};

export default SimpleCard;
